import { useEffect, useState } from 'react';
import api from '../../api';

const useGetMarketOperators = () => {
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState([]);

    const getAllMarketOperators = async () => {
        try {
            const response = await api.get_market_operators();
            setData(response.data);
        } catch (error) {
            console.error('Error happened while loading market operators. ', error);
        } finally {
            setIsReady(true);
        }
    };

    useEffect(() => {
        getAllMarketOperators();
    }, []);

    return { isReady, data };
};

export default useGetMarketOperators;
